import { render, staticRenderFns } from "./IntroHero.vue?vue&type=template&id=615fe030&scoped=true&"
var script = {}
import style0 from "./IntroHero.vue?vue&type=style&index=0&id=615fe030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615fe030",
  null
  
)

export default component.exports